import Modal from '@acorn-portal/shared/src/components-v2/modal';
import { Box, Button, DialogTitle, Link, Typography } from '@mui/material';
import ModalContentWrapper from '../modal-content-wrapper';

interface IErrorModal {
	open: boolean;
	onClose: () => void;
	contactNumber: string;
}

/**
 * Error modal component that displays contact information based on the company.
 */
const ErrorModal = ({ open, onClose, contactNumber }: IErrorModal) => {
	return (
		<Modal open={open} onClose={onClose}>
			<ModalContentWrapper>
				<DialogTitle component='h2' variant='h5' sx={{ fontWeight: 700, m: 0, p: 0, textAlign: 'center' }}>
					Something went wrong
				</DialogTitle>
				<Typography sx={{ textAlign: 'center', my: '1em' }}>
					Please try again or call us
					{contactNumber ? (
						<>
							{' '}
							on <strong>{contactNumber}</strong>
						</>
					) : null}{' '}
					if this problem persists.
				</Typography>
				<Box sx={{ display: { xs: 'block', sm: 'none' }, mt: '1.5em' }}>
					{contactNumber && (
						<Button
							component={Link}
							variant='contained'
							href={`tel:${contactNumber}`}
							size='large'
							sx={{
								width: '100%',
								mb: '1em',
							}}
						>
							Call us
						</Button>
					)}
					<Button
						variant='text'
						onClick={onClose}
						size='large'
						sx={{
							border: 'solid 1px',
							borderColor: 'primary.main',
							px: '1rem',
							width: '100%',
						}}
					>
						Close
					</Button>
				</Box>
			</ModalContentWrapper>
		</Modal>
	);
};

export default ErrorModal;
